import { type FC, type ReactNode } from 'react';

import { SegmentedControl } from '@zen/DesignSystem';
import { useQueryParams } from '@zen/utils/QueryParams';

import ProductAttributes from '../ProductAttributes';
import ProductCategories from '../ProductCategories';
import type { ProductSettingsTab } from '../types';

interface Props {
  accountId: string;
  canCreateProductAttribute: boolean;
  canCreateProductCategory: boolean;
}

const ProductSettings: FC<Props> = ({ accountId, canCreateProductAttribute, canCreateProductCategory }) => {
  const { queryParams, setQueryParams } = useQueryParams<{ type: ProductSettingsTab }>();
  const { type = 'product-categories' } = queryParams;

  const componentMapping: Record<ProductSettingsTab, ReactNode> = {
    'product-categories': <ProductCategories accountId={accountId} canCreateProductCategory={canCreateProductCategory} />,
    'product-attributes': <ProductAttributes accountId={accountId} canCreateProductAttribute={canCreateProductAttribute} />
  };

  return (
    <div>
      <SegmentedControl
        onChange={(productSettingsType: ProductSettingsTab) => setQueryParams({ type: productSettingsType })}
        options={[
          { value: 'product-categories', label: 'Categories' },
          { value: 'product-attributes', label: 'Attribute types' }
        ]}
        value={type}
      />
      <div className="mt-4">{componentMapping[type]}</div>
    </div>
  );
};

export default ProductSettings;
